import React from 'react'
import { useViewport } from '@chilecompra/react-kit'
import { Skeleton, Typography } from '@chilecompra/react-kit/components'
import { Grid } from './QuoteSearchResults.styles'

/*
 * The SkeletonRow's component
 */
const SkeletonRow = () => {
  const {
    size: { isUpToSmall, isUpToMedium }
  } = useViewport()

  return (
    <Grid alignItems="center" container>
      <Grid container direction="column" item md={3} padding={!isUpToMedium ? '0 0 10px 0' : '0'}>
        <Grid alignItems="center" container item justifyContent="space-between">
          <Typography color="black3" variant="subtitle">
            <Skeleton width="100px" />
          </Typography>
          {!isUpToMedium && <Skeleton width="90px" />}
        </Grid>
        <Grid item>
          <Typography color="black1" fontWeight="bold" margin="4px 0" variant="body1">
            <Skeleton width="150px" />
          </Typography>
        </Grid>
        <Typography color="black3" variant="subtitle">
          <Skeleton width="80px" />
        </Typography>
      </Grid>
      <Grid alignItems="center" item container md>
        <Grid container direction="column" item md textAlign={isUpToSmall ? 'center' : 'left'} xs={6}>
          <Typography color="black3" variant="subtitle">
            <Skeleton width="80px" />
          </Typography>
          <Typography color="black1" variant="body1">
            <Skeleton width="80px" />
          </Typography>
          <Typography color="black3" variant="subtitle">
            <Skeleton width="80px" />
          </Typography>
        </Grid>
        <Grid container direction="column" item md textAlign={isUpToSmall ? 'center' : 'right'} xs={6}>
          <Typography color="black3" variant="subtitle">
            <Skeleton width="80px" />
          </Typography>
          <Typography color="black1" variant="body1">
            <Skeleton width="80px" />
          </Typography>
          <Typography color="black3" variant="subtitle">
            <Skeleton width="80px" />
          </Typography>
        </Grid>
        {isUpToMedium && (
          <Grid container item md justifyContent={isUpToMedium ? 'center' : 'flex-end'}>
            <Skeleton width="90px" />
          </Grid>
        )}
        <Grid container item xs={12} md justifyContent="center" padding={!isUpToMedium ? '10px 0 0' : '0'}>
          <Skeleton width="90px" />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default SkeletonRow
